export default __webpack_public_path__ + "static/media/calculate-ar.83368d59.svg";